import { render, staticRenderFns } from "./Materials.vue?vue&type=template&id=31426751&scoped=true"
import script from "./Materials.vue?vue&type=script&lang=js"
export * from "./Materials.vue?vue&type=script&lang=js"
import style0 from "./Materials.vue?vue&type=style&index=0&id=31426751&prod&scoped=true&lang=css"
import style1 from "./Materials.vue?vue&type=style&index=1&id=31426751&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31426751",
  null
  
)

export default component.exports